module.exports = __webpack_public_path__ + "img/faq6.6530113d.svg";